'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@base-ui-components/react/scroll-area";
import { cn } from "../../utils/index.js";
import { scrollAreaVariants } from "./ScrollArea.variants.js";
function ScrollArea_ScrollArea({ children, className, headerNode, ...props }) {
    const { root, viewport, content, scrollbar, thumb } = scrollAreaVariants(props);
    return /*#__PURE__*/ jsxs(ScrollArea.Root, {
        className: cn(root(), className),
        children: [
            /*#__PURE__*/ jsxs(ScrollArea.Viewport, {
                className: viewport(),
                children: [
                    headerNode,
                    /*#__PURE__*/ jsx("div", {
                        className: content(),
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ jsx(ScrollArea.Scrollbar, {
                className: scrollbar(),
                children: /*#__PURE__*/ jsx(ScrollArea.Thumb, {
                    className: thumb()
                })
            })
        ]
    });
}
export { ScrollArea_ScrollArea as ScrollArea };
